import { render, staticRenderFns } from "./product_labels.vue?vue&type=template&id=517074c1&scoped=true&"
import script from "./product_labels.vue?vue&type=script&lang=js&"
export * from "./product_labels.vue?vue&type=script&lang=js&"
import style0 from "./product_labels.vue?vue&type=style&index=0&id=517074c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517074c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517074c1')) {
      api.createRecord('517074c1', component.options)
    } else {
      api.reload('517074c1', component.options)
    }
    module.hot.accept("./product_labels.vue?vue&type=template&id=517074c1&scoped=true&", function () {
      api.rerender('517074c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_labels.vue"
export default component.exports